import { displayPartnerCustomerList } from '../../../../widgets/partner-customer-widget';
import { getSelectedItem } from './select-items';
import { searchAvailList } from './search-list';
import useAuth from '../../../../../hooks/auth-hooks';

import { getTerminals } from '../../../../../routes/get-terminal';

/**
 * Function that gets a list of terminal data and displays it.
 */
const GetTerminalData = async () => {
  const { accessType } = useAuth()!;

  if ( accessType != 'E' ) return;

  const { body } = await getTerminals();

  const mapList = Object.values(body).map((r: any) => ({
    id: r.terminalId,
    name: `${r.terminalName} | ${r.partnerName}`
  }));

  const terminalList = document.querySelectorAll<HTMLElement>('[data-id');
  const available = Array.from(terminalList).map(e => ({
    terminalId: e.getAttribute('data-id')
  }));

  const availTerminals = mapList.filter(item => available.every(item2 => item2.terminalId != item.id));
  const avaListContainer = document.querySelector('.aafp_list-result-container') as HTMLElement;
  const searchBar = document.querySelector('#aafp_customer-input') as HTMLInputElement;
  const con = document.querySelector('.aafp_terminal-container') as HTMLElement;
  if (avaListContainer) {
    avaListContainer.innerText = '';
    displayPartnerCustomerList(availTerminals, avaListContainer);

    getSelectedItem(avaListContainer, con);
    searchAvailList(searchBar, avaListContainer);
  }
}

export default GetTerminalData;